import React from 'react'
import Home from './Home'
import Gallery from './Gallery'
import Appointment from './Appointment'
import Services from './Services'
import Contact from './Contact'

// TODO: Build Services Component
// TODO: Build pricing component (may be part of services)
// TODO: Build gallery component

function Main(props) {
    
    if (props.activePage === 'services') {
        return (
            <div className='main'>
                <Services />
            </div>    
        )
    } else if (props.activePage === 'appointment') {
        return (
            <div className='main'>
                <Appointment />
            </div>
        )
    } else if (props.activePage === 'gallery') {
        return (
            <div className='main'>
                <Gallery />
            </div>
        )
    } else if (props.activePage === 'contact') {
        return (
            <div className='main'>
                <Contact />
            </div>
        )
    } else {
        return (
            <div className='main'>
                <Home
                    isLoggedIn={props.isLoggedIn}
                />
            </div>
        )
    }
}

export default Main